import { render, staticRenderFns } from "./CpuModule.vue?vue&type=template&id=38e0b746&scoped=true"
import script from "./CpuModule.vue?vue&type=script&lang=js"
export * from "./CpuModule.vue?vue&type=script&lang=js"
import style0 from "./CpuModule.vue?vue&type=style&index=0&id=38e0b746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0b746",
  null
  
)

export default component.exports